import React, { useRef, useState, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import './ParallaxModal.css';
import ParallaxSystem from './ParallaxSystem';
import Anima from '../main/Anima';
import { useTranslation } from 'react-i18next'; // Importer useTranslation

const Modal = ({ isOpen, onClose, children }) => {
  const [display, setDisplay] = useState(isOpen);

  useEffect(() => {
    let timer;
    if (isOpen) {
      setDisplay(true);
    } else {
      timer = setTimeout(() => setDisplay(false), 500);
    }
    return () => clearTimeout(timer);
  }, [isOpen]);

  const overlayAnimation = useSpring(Anima.overlayAnimationConfig(isOpen));
  const contentAnimation = useSpring(Anima.contentAnimationConfig(isOpen));

  if (!display) {
    return null;
  }

  return (
    <animated.div className="Overlay" style={overlayAnimation} onClick={onClose}>
      <animated.div className="Modal" style={contentAnimation} onClick={(e) => e.stopPropagation()}>
        {children}
      </animated.div>
    </animated.div>
  );
};

const ParallaxModal = ({ isOpen, onClose, category, modelName }) => {
  const { i18n } = useTranslation(); // Récupérer la langue actuelle détectée par i18n
  const parallaxRef = useRef();

  // Déterminez si vous devez afficher le bouton "..." basé sur la catégorie
  const shouldShowNextButton = !['fortunam', 'monteRosa', 'OAM'].includes(category);

  const handleNext = () => {
    if (parallaxRef.current) {
      parallaxRef.current.goToNextPage();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <button onClick={onClose} className="close-button">+</button>
      <ParallaxSystem ref={parallaxRef} category={category} language={i18n.language} modelName={modelName} />
      {shouldShowNextButton && (
        <button className="next-button" onClick={handleNext}>...</button>
      )}
    </Modal>
  );
};

export default ParallaxModal;